/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../hebrewdatehelpers/hebrewdatehelpers.ts" />
/// <reference path="../positioning/positioning.ts" />
/// <reference path="../dropdown/dropdown.ts" />
/// <reference path="../htmlhelpers/htmlhelpers.ts" />

namespace Teva {
    export enum DatePickerMode {
        Date,
        DateTime,
        Month,
        Time,
        DateWithoutYear
    }

    export interface DatePickerLocaleProvider {
        MonthNames(): Array<string>;
        DayLetters(): Array<string>;
        PickYear(): string;
        PickMonth(): string;
        PickDay(): string;
        PickTime(): string;
        PickHour(): string;
        PickMinute(): string;
        IsRTL(): boolean;
        SelectCurrentDay(): string;
        SelectCurrentMonth(): string;
        SelectCurrentYear(): string;
        SelectCurrentTime(): string;
    }

    export class DatePicker_HE implements DatePickerLocaleProvider {
        DayLetters(): Array<string> {
            return ["א", "ב", "ג", "ד", "ה", "ו", "ש"];
        }
        PickDay() {
            return "בחירת יום";
        }
        PickMonth() {
            return "בחירת חודש";
        }
        PickYear() {
            return "בחירת שנה";
        }
        PickTime() {
            return "בחירת שעה";
        }
        PickHour() {
            return "בחירת שעה";
        }
        PickMinute() {
            return "בחירת דקה";
        }
        MonthNames() {
            return ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];
        }
        IsRTL() {
            return true;
        }
        SelectCurrentDay() {
            return "בחירת היום";
        }
        SelectCurrentMonth() {
            return "בחירת החודש";
        }
        SelectCurrentYear() {
            return "בחירת השנה";
        }
        SelectCurrentTime() {
            return "בחירת עכשיו";
        }
    }

    export class DatePicker_EN implements DatePickerLocaleProvider {
        DayLetters(): Array<string> {
            return ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
        }
        PickDay() {
            return "Pick day";
        }
        PickMonth() {
            return "Pick month";
        }
        PickYear() {
            return "Pick year";
        }
        PickTime() {
            return "Pick time";
        }
        PickHour() {
            return "Pick hour";
        }
        PickMinute() {
            return "Pick minute";
        }
        MonthNames() {
            return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        }
        IsRTL() {
            return false;
        }
        SelectCurrentDay() {
            return "Select today";
        }
        SelectCurrentMonth() {
            return "Select current month";
        }
        SelectCurrentYear() {
            return "Select current year";
        }
        SelectCurrentTime() {
            return "Select now";
        }
    }

    export class DatePicker {
        static Init(): void {
            if (document.body.dir == "rtl")
                DatePicker.LocaleProvider = new DatePicker_HE();
            else
                DatePicker.LocaleProvider = new DatePicker_EN();
            $(document.body)
                .on("click.datepicker", "input.datepicker, input.datetimepicker, input.timepicker, input.monthpicker, input.datewithoutyearpicker", function () {
                    var $Input = $(this);
                    if ($Input.data("datepicker") != null)
                        return false;
                    if ($Input.data("datepicker-ignoreevent") == true) {
                        $Input.data("datepicker-ignoreevent", false);
                        return false;
                    }
                    if ($Input.attr("readonly") == "readonly")
                        return false;

                    var Mode;
                    if ($Input.hasClass("datepicker"))
                        Mode = DatePickerMode.Date;
                    else if ($Input.hasClass("datetimepicker"))
                        Mode = DatePickerMode.DateTime;
                    else if ($Input.hasClass("monthpicker"))
                        Mode = DatePickerMode.Month;
                    else if ($Input.hasClass("timepicker"))
                        Mode = DatePickerMode.Time;
                    else if ($Input.hasClass("datewithoutyearpicker"))
                        Mode = DatePickerMode.DateWithoutYear;
                    var HebrewCalendar = $Input.data("datepicker-calendar") == "hebrew";
                    if (HebrewCalendar)
                        return false;

                    Teva.Dropdown.Hide();

                    var Instance = new DatePicker($Input, Mode, HebrewCalendar);
                    Instance.Show();
                    $(document).trigger("click.SelectBox");
                    return false;
                })
                .on("change.datepicker", "input.datepicker, input.datetimepicker, input.timepicker, input.monthpicker, input.datewithoutyear", function () {
                    var $Input = $(this);
                    var HebrewCalendar = $Input.data("datepicker-calendar") == "hebrew";
                    if (HebrewCalendar)
                        return false;

                    DatePicker.InputChange($Input);
                });

        }
        static InputChange($Input) {
            if ($Input.hasClass("datepicker"))
                DatePicker.FixDate($Input);
            else if ($Input.hasClass("datetimepicker"))
                DatePicker.FixDateTime($Input);
            else if ($Input.hasClass("monthpicker"))
                DatePicker.FixMonth($Input);
            else if ($Input.hasClass("timepicker"))
                DatePicker.FixTime($Input);
            else if ($Input.hasClass("datewithoutyearpicker"))
                DatePicker.FixDateWithoutYear($Input);
        }
        static PageLoad() {
            $(document).trigger("click.datepicker-hide");
        }

        constructor($Input, Mode?, HebrewCalendar?) {
            var Instance = this;
            Instance.$Input = $Input;
            Instance.HebrewCalendar = HebrewCalendar;
            Instance.$Input.data("datepicker", this);
            if (Mode == null) {
                switch (Instance.$Input.data("datepicker-mode")) {
                    case "DateTime":
                        Instance.Mode = DatePickerMode.DateTime;
                        break;
                    case "Month":
                        Instance.Mode = DatePickerMode.Month;
                        break;
                    case "Time":
                        Instance.Mode = DatePickerMode.Time;
                        break;
                    case "DateWithoutYear":
                        Instance.Mode = DatePickerMode.DateWithoutYear;
                        break;
                    case "Date":
                    default:
                        Instance.Mode = DatePickerMode.Date;
                        break;
                }
            }
            else
                Instance.Mode = Mode;
            if (Instance.$Input.val() != "") {
                switch (Instance.Mode) {
                    case DatePickerMode.DateTime:
                        DatePicker.FixDateTime(Instance.$Input);
                        var Value = Instance.$Input.val();
                        Instance.SelectedDay = Number(Value.substring(0, 2));
                        Instance.SelectedMonth = Number(Value.substring(3, 5));
                        Instance.SelectedYear = Number(Value.substring(6, 10));
                        Instance.SelectedHour = Number(Value.substring(11, 13));
                        Instance.SelectedMinute = Number(Value.substring(14, 16));
                        break;
                    case DatePickerMode.Date:
                        DatePicker.FixDate(Instance.$Input);
                        var Value = Instance.$Input.val();
                        Instance.SelectedDay = Number(Value.substring(0, 2));
                        Instance.SelectedMonth = Number(Value.substring(3, 5));
                        Instance.SelectedYear = Number(Value.substring(6, 10));
                        break;
                    case DatePickerMode.Month:
                        DatePicker.FixMonth(Instance.$Input);
                        var Value = Instance.$Input.val();
                        Instance.SelectedMonth = Number(Value.substring(0, 2));
                        Instance.SelectedYear = Number(Value.substring(3, 7));
                        break;
                    case DatePickerMode.Time:
                        DatePicker.FixTime(Instance.$Input);
                        var Value = Instance.$Input.val();
                        Instance.SelectedHour = Number(Value.substring(0, 2));
                        Instance.SelectedMinute = Number(Value.substring(3, 5));
                        break;
                    case DatePickerMode.DateWithoutYear:
                        DatePicker.FixDateWithoutYear(Instance.$Input);
                        var Value = Instance.$Input.val();
                        Instance.SelectedDay = Number(Value.substring(0, 2));
                        Instance.SelectedMonth = Number(Value.substring(3, 5));
                        Instance.SelectedYear = 2000;
                        break;
                }
            }
            else {
                var Now = new Date();
                Instance.SelectedDay = Now.getDate();
                Instance.SelectedMonth = Now.getMonth() + 1;
                Instance.SelectedYear = Now.getFullYear();
                if (Instance.Mode == DatePickerMode.DateTime) {
                    Instance.SelectedHour = 0;
                    Instance.SelectedMinute = 0;
                }
                else {
                    Instance.SelectedHour = Now.getHours();
                    Instance.SelectedMinute = Now.getMinutes();
                }
            }

            Instance.VisibleMonth = Instance.SelectedMonth;
            Instance.VisibleYear = Instance.SelectedYear;
        }

        Show(): void {
            $(document).trigger("click.datepicker-hide");

            var Instance = this;
            Instance.$Container = $(document.createElement('div'))
                .data("datepicker", Instance)
                .addClass("teva-datepicker");

            if (window.innerWidth < 640 || document.documentElement.clientWidth < 640) {
                Instance.$Container.addClass("teva-datepicker-mobile");
                Instance.$Input.blur();
            }

            if (Instance.Mode == DatePickerMode.Date || Instance.Mode == DatePickerMode.DateTime || Instance.Mode == DatePickerMode.DateWithoutYear)
                Instance.ShowDatePicker();
            else if (Instance.Mode == DatePickerMode.Month)
                Instance.ShowMonthPicker();
            else if (Instance.Mode == DatePickerMode.Time)
                Instance.ShowTimePicker();

            $(document.body).append(Instance.$Container.hide());
            if (!Instance.$Container.hasClass("teva-datepicker-mobile"))
                Teva.Positioning.PositionBelow_Start(Instance.$Container, Instance.$Input, "datepicker");
            Instance.$Container.show();

            Instance.$Container.on("click", function (Event) {
                Event.stopPropagation();
                if (Instance.$DateContainer != null && $(Event.target).closest(Instance.$DateContainer).length != 0)
                    return true;
                if (Instance.$MonthCalendar != null && $(Event.target).closest(Instance.$MonthCalendar).length != 0)
                    return true;
                if (Instance.$YearCalendar != null && $(Event.target).closest(Instance.$YearContainer).length != 0)
                    return true;
                if (Instance.$TimeContainer != null && $(Event.target).closest(Instance.$TimeContainer).length != 0)
                    return true;
                Instance.Hide(true);
                return true;
            });
            $(document).on("keydown.datepicker-hide", function () {
                Instance.Hide(true);
            });
            $(document).on("click.datepicker-hide", function (Event) {
                if (Instance.$DateContainer != null && $(Event.target).closest(Instance.$DateContainer).length != 0)
                    return true;
                if (Instance.$MonthCalendar != null && $(Event.target).closest(Instance.$MonthCalendar).length != 0)
                    return true;
                if (Instance.$YearCalendar != null && $(Event.target).closest(Instance.$YearContainer).length != 0)
                    return true;
                if (Instance.$TimeContainer != null && $(Event.target).closest(Instance.$TimeContainer).length != 0)
                    return true;
                Instance.Hide(false);
                return true;
            });
            if (!Instance.$Container.hasClass("teva-datepicker-mobile"))
                Teva.Positioning.ScrollToElement(Instance.$Input);
        }
        Hide(Refocus): void {
            var Instance = this;
            if (!Instance.$Container.hasClass("teva-datepicker-mobile"))            
                Teva.Positioning.PositionBelow_Stop(Instance.$Input, "datepicker");
            Instance.$Container.remove();
            Instance.$Container = null;
            Instance.DestoryDateContainer();
            Instance.DestoryMonthContainer();
            Instance.DestoryYearContainer();
            Instance.DestoryTimeContainer();
            Instance.$Input.data("datepicker", null);
            if (Refocus)
                Instance.$Input.data("datepicker-ignoreevent", true).trigger("focus");
            $(document)
                .off("click.datepicker-hide")
                .off("keydown.datepicker-hide");
        }

        /*private IncrementSelectedHour() {
            var Instance = this;
            if (Instance.SelectedHour == 23) {
                Instance.SelectedHour = 0;
                Instance.IncrementSelectedDay();
            }
            else
                Instance.SelectedHour++;
        }
        private DecrementSelectedHour() {
            var Instance = this;
            if (Instance.SelectedHour == 0) {
                Instance.SelectedHour = 23;
                Instance.DecrementSelectedDay();
            }
            else
                Instance.SelectedHour--;
        }*/
        private IncrementSelectedDay() {
            var Instance = this;
            if (new Date(Instance.SelectedYear, Instance.SelectedMonth - 1, Instance.SelectedDay + 1).getDate() != Instance.SelectedDay + 1) {
                Instance.IncrementSelectedMonth();
                Instance.SelectedDay = 1;
            }
            else
                Instance.SelectedDay++;
        }
        private DecrementSelectedDay() {
            var Instance = this;
            if (Instance.SelectedDay == 1) {
                Instance.DecrementSelectedMonth();
                Instance.SelectedDay = Instance.GetDaysInMonth(Instance.SelectedYear, Instance.SelectedMonth);
            }
            else
                Instance.SelectedDay--;
        }
        private IncrementVisibleMonth() {
            var Instance = this;
            if (Instance.VisibleMonth == 12) {
                Instance.VisibleMonth = 1;
                Instance.VisibleYear++;
            }
            else
                Instance.VisibleMonth++;
        }
        private DecrementVisibleMonth() {
            var Instance = this;
            if (Instance.VisibleMonth == 1) {
                Instance.VisibleMonth = 12;
                Instance.VisibleYear--;
            }
            else
                Instance.VisibleMonth--;
        }
        private IncrementSelectedMonth() {
            var Instance = this;
            if (Instance.SelectedMonth == 12) {
                Instance.SelectedMonth = 1;
                Instance.SelectedYear++;
            }
            else
                Instance.SelectedMonth++;
        }
        private DecrementSelectedMonth() {
            var Instance = this;
            if (Instance.SelectedMonth == 1) {
                Instance.SelectedMonth = 12;
                Instance.SelectedYear--;
            }
            else
                Instance.SelectedMonth--;
        }
        private Empty() {
            var Instance = this;
            Instance.$Input.val("");
            Instance.Hide(true);
        }

        private CreateDateContainer() {
            var Instance = this;
            var DayNames = DatePicker.LocaleProvider.DayLetters();
            Instance.$DateContainer = $(document.createElement('div'))
                .addClass("teva-datepicker-date")
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-date-remove")
                    .on("click", function (Event) {
                        Instance.Empty();
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-date-close")
                    .on("click", function (Event) {
                        Instance.Hide(true);
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-date-header")
                    .text(DatePicker.LocaleProvider.PickDay())
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-date-menu")
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-date-menu-previous")
                        .on("click", function () {
                            Instance.DecrementVisibleMonth();
                            Instance.RefreshDateCalendar();
                        }))
                    .append(Instance.$DateHeader = $(document.createElement('div'))
                        .addClass("teva-datepicker-date-menu-header")
                        .on("click", function (Event) {
                            Instance.ShowMonthPicker();
                            Event.stopPropagation();
                        }))
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-date-menu-next")
                        .on("click", function () {
                            Instance.IncrementVisibleMonth();
                            Instance.RefreshDateCalendar();
                        }))
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-date-options")
                    .append($(document.createElement('div'))
                        .append($(document.createElement('div')).text(DayNames[0]))
                        .append($(document.createElement('div')).text(DayNames[1]))
                        .append($(document.createElement('div')).text(DayNames[2]))
                        .append($(document.createElement('div')).text(DayNames[3]))
                        .append($(document.createElement('div')).text(DayNames[4]))
                        .append($(document.createElement('div')).text(DayNames[5]))
                        .append($(document.createElement('div')).text(DayNames[6]))
                        .addClass("teva-datepicker-date-options-header")
                    )
                    .append(Instance.$DateCalendar = $(document.createElement('div'))
                        .addClass("teva-datepicker-date-options-calendar")
                    )
                )
                .append(Instance.$NowButton = $(document.createElement('div'))
                    .addClass("teva-datepicker-date-now")
                    .on("click", Instance.Now_Selected)
                )
                .appendTo(Instance.$Container);
        }
        private CreateMonthContainer() {
            var Instance = this;
            Instance.$MonthContainer = $(document.createElement('div'))
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-month-remove")
                    .on("click", function (Event) {
                        Instance.Empty();
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-month-close")
                    .on("click", function (Event) {
                        Instance.Hide(true);
                        Event.stopPropagation();
                    })
                )
                .addClass("teva-datepicker-month")
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-month-header")
                    .text(DatePicker.LocaleProvider.PickMonth())
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-month-menu")
                    .css("visibility", Instance.Mode == DatePickerMode.DateWithoutYear ? "hidden" : "")
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-month-menu-previous")
                        .on("click", function (Event) {
                            Instance.VisibleYear--;
                            Instance.RefreshMonthCalendar();
                            Event.stopPropagation();
                        }))
                    .append(Instance.$MonthHeader = $(document.createElement('div'))
                        .addClass("teva-datepicker-month-menu-header")
                        .on("click", function (Event) {
                            Instance.ShowYearPicker();
                            Event.stopPropagation();
                        }))
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-month-menu-next")
                        .on("click", function (Event) {
                            Instance.VisibleYear++;
                            Instance.RefreshMonthCalendar();
                            Event.stopPropagation();
                        }))
                )
                .append(Instance.$MonthCalendar = $(document.createElement('div'))
                    .addClass("teva-datepicker-month-calendar"))
                .append(Instance.$NowButton = $(document.createElement('div'))
                    .addClass("teva-datepicker-month-now")
                    .on("click", Instance.Now_Selected)
                )
                .appendTo(Instance.$Container);
        }
        private CreateYearContainer() {
            var Instance = this;
            Instance.$YearContainer = $(document.createElement('div'))
                .addClass("teva-datepicker-year")
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-year-remove")
                    .on("click", function (Event) {
                        Instance.Empty();
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-year-close")
                    .on("click", function (Event) {
                        Instance.Hide(true);
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-year-header")
                    .text(DatePicker.LocaleProvider.PickYear())
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-year-menu")
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-year-menu-previous")
                        .on("click", function () {
                            Instance.VisibleYear -= 12;
                            Instance.RefreshYearCalendar();
                        }))
                    .append(Instance.$YearHeader = $(document.createElement('div'))
                        .addClass("teva-datepicker-year-menu-header"))
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-year-menu-next")
                        .on("click", function () {
                            Instance.VisibleYear += 12;
                            Instance.RefreshYearCalendar();
                        }))
                )
                .append(Instance.$YearCalendar = $(document.createElement('div'))
                    .addClass("teva-datepicker-year-calendar"))
                .append(Instance.$NowButton = $(document.createElement('div'))
                    .addClass("teva-datepicker-year-now")
                    .on("click", Instance.Now_Selected)
                )
                .appendTo(Instance.$Container);
        }
        private CreateTimeContainer() {
            var Instance = this;
            var Mousedown = false;
            Instance.$TimeContainer = $(document.createElement('div'))
                .addClass("teva-datepicker-time")
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-time-remove")
                    .on("click", function (Event) {
                        Instance.Empty();
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-time-close")
                    .on("click", function (Event) {
                        Instance.Hide(true);
                        Event.stopPropagation();
                    })
                )
                .append($(document.createElement('div'))
                    .addClass("teva-datepicker-time-header")
                    .text(DatePicker.LocaleProvider.PickTime())
                );

            if (Instance.Mode != DatePickerMode.Time) {
                Instance.$TimeContainer.append($(document.createElement('div'))
                    .addClass("teva-datepicker-time-menu")
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-time-menu-previous")
                        .on("click", function () {
                            Instance.DecrementSelectedDay();
                            Instance.RefreshInput();
                            Instance.RefreshTime();
                        }))
                    .append(Instance.$TimeHeader = $(document.createElement('div'))
                        .addClass("teva-datepicker-time-menu-header")
                        .on("click", function (Event) {
                            Instance.ShowDatePicker();
                            Event.stopPropagation();
                        }))
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-time-menu-next")
                        .on("click", function () {
                            Instance.IncrementSelectedDay();
                            Instance.RefreshInput();
                            Instance.RefreshTime();
                        }))
                )
            }

            Instance.$TimeContainer.find(".teva-datepicker-time-header")[0].innerText = DatePicker.LocaleProvider.PickHour();

            var TouchSupported = 'ontouchstart' in window;
            var MousedownEvent = 'mouseenter.datepicker mousedown.datepicker' + (TouchSupported ? ' touchstart.datepicker' : '');
            var MouseupEvent = 'mouseup.datepicker' + (TouchSupported ? ' touchend.datepicker' : '');

            var $HourOptions, $MinuteOptions;
            var $HourMinuteContainer;
            Instance.$TimeContainer
                .append($HourMinuteContainer = $(document.createElement('div'))
                    .addClass("teva-datepicker-time-hourminutecontainer")
                )
                .appendTo(Instance.$Container);

            $(document.createElement('svg'))
                .addClass("teva-datepicker-time-hand")
                .append($(document.createElement('g'))
                    .append($(document.createElement('line'))
                        .attr("x1", "120")
                        .attr("y1", "120")
                        .attr("x2", "0")
                        .attr("y2", "0")
                    )
                    .append($(document.createElement('g'))
                        .attr("cx", "120")
                        .attr("cy", "120")
                        .attr("r", "4")
                    )
                )
                .appendTo($HourMinuteContainer);
            $HourMinuteContainer.html($HourMinuteContainer.html());
            var $Hand = $HourMinuteContainer.find("line");
            
            $("svg.teva-datepicker-time-hand", $HourMinuteContainer);

            var SetHand = function (Index, Long) {
                $Hand[0].setAttribute("y2", 120 + Math.sin((Index - 3) * Math.PI / 6) * (Long ? 100 : 70));
                $Hand[0].setAttribute("x2", 120 + Math.cos((Index - 3) * Math.PI / 6) * (Long ? 100 : 70));
            };

            SetHand(Instance.SelectedHour, Instance.SelectedHour > 1 && Instance.SelectedHour <= 12);
            $HourOptions = $(document.createElement('div'))
                .addClass("teva-datepicker-time-hourpicker")
                .show()
                .appendTo($HourMinuteContainer);
            var HourOptionsFragment = <JQuery><any>$(document.createDocumentFragment());
            for (var i = 1; i < 13; i++) {
                $(document.createElement('div'))
                    .css("top", 106 + Math.sin((i - 3) * Math.PI / 6) * 100)
                    .css("left", 106 + Math.cos((i - 3) * Math.PI / 6) * 100)
                    .addClass("teva-datepicker-time-hourpicker-option")
                    .toggleClass("teva-datepicker-time-hourpicker-option-selected", Instance.SelectedHour == i)
                    .text(i)
                    .on(MousedownEvent, function (Event) {
                        if (Event.button == 0 && Instance.SelectedHour != Number(this.innerText)) {
                            $HourOptions.find(".teva-datepicker-time-hourpicker-option-selected").removeClass("teva-datepicker-time-hourpicker-option-selected");
                            this.addClass("teva-datepicker-time-hourpicker-option-selected");
                            if (Instance.SelectedHour != Number(this.innerText)) {
                                Instance.SelectedHour = Number(this.innerText);
                                Instance.SelectedMinute = 0;
                                Instance.RefreshInput();
                                Instance.RefreshTime();
                            }
                            SetHand(Number(this.innerText), true);
                        }
                    })
                    .on(MouseupEvent, function (Event) {
                        if (Event.button != 0)
                            return true;

                        if (Instance.SelectedHour != Number(this.innerText)) {
                            Instance.SelectedHour = Number(this.innerText);
                            Instance.SelectedMinute = 0;
                            Instance.RefreshInput();
                            Instance.RefreshTime();
                        }
                        $HourOptions.fadeOut();
                        $MinuteOptions.fadeIn();
                        Instance.$TimeContainer.find(".teva-datepicker-time-header")[0].innerText = DatePicker.LocaleProvider.PickMinute();
                        SetHand(Instance.SelectedMinute / 5, true);
                        return false;
                    })
                    .appendTo(HourOptionsFragment);
            }
            for (i = 13; i < 25; i++) {
                $(document.createElement('div'))
                    .css("top", 106 + Math.sin((i - 12 - 3) * Math.PI / 6) * 70)
                    .css("left", 106 + Math.cos((i - 12 - 3) * Math.PI / 6) * 70)
                    .addClass("teva-datepicker-time-hourpicker-option")
                    .toggleClass("teva-datepicker-time-hourpicker-option-selected", Instance.SelectedHour == i)
                    .text(i == 24 ? "00" : i)
                    .on(MousedownEvent, function (Event) {
                        if (Event.button == 0 && Instance.SelectedHour != Number(this.innerText)) {
                            $HourOptions.find(".teva-datepicker-time-hourpicker-option-selected").removeClass("teva-datepicker-time-hourpicker-option-selected");
                            this.addClass("teva-datepicker-time-hourpicker-option-selected");
                            if (Instance.SelectedHour != Number(this.innerText)) {
                                Instance.SelectedHour = Number(this.innerText);
                                Instance.SelectedMinute = 0;
                                Instance.RefreshInput();
                                Instance.RefreshTime();
                            }
                            Instance.RefreshInput();
                            Instance.RefreshTime();
                            SetHand(Number(this.innerText), false);
                        }
                    })
                    .on(MouseupEvent, function (Event) {
                        if (Event.button != 0)
                            return true;

                        if (Instance.SelectedHour != Number(this.innerText)) {
                            Instance.SelectedHour = Number(this.innerText);
                            Instance.SelectedMinute = 0;
                            Instance.RefreshInput();
                            Instance.RefreshTime();
                        }
                        Instance.RefreshInput();
                        Instance.RefreshTime();
                        $HourOptions.fadeOut();
                        $MinuteOptions.fadeIn();
                        Instance.$TimeContainer.find(".teva-datepicker-time-header")[0].innerText = DatePicker.LocaleProvider.PickMinute();
                        SetHand(Instance.SelectedMinute / 5, true);
                        return false;
                    })
                    .appendTo(HourOptionsFragment);
            }
            $HourOptions.append(HourOptionsFragment);

            $MinuteOptions = $(document.createElement('div'))
                .addClass("teva-datepicker-time-minutepicker")
                .hide()
                .appendTo($HourMinuteContainer);
            var MinuteOptionsFragment = <JQuery><any>$(document.createDocumentFragment());
            for (i = 1; i < 13; i++) {
                $(document.createElement('div'))
                    .css("top", 106 + Math.sin((i - 12 - 3) * Math.PI / 6) * 100)
                    .css("left", 106 + Math.cos((i - 12 - 3) * Math.PI / 6) * 100)
                    .addClass("teva-datepicker-time-minutepicker-option")
                    .toggleClass("teva-datepicker-time-minutepicker-option-selected", Instance.SelectedMinute == (i == 12 ? 0 : i * 5))
                    .text(i == 12 ? "00" : i * 5)
                    .on(MousedownEvent, function (Event) {
                        if (Event.button == 0 && Instance.SelectedMinute != Number(this.innerText)) {
                            $MinuteOptions.find(".teva-datepicker-time-minutepicker-option-selected").removeClass("teva-datepicker-time-minutepicker-option-selected");
                            this.addClass("teva-datepicker-time-minutepicker-option-selected");
                            Instance.SelectedMinute = Number(this.innerText);
                            Instance.RefreshInput();
                            Instance.RefreshTime();
                            SetHand(Number(this.innerText) / 5, true);
                        }
                    })
                    .on(MouseupEvent, function (Event) {
                        if (Event.button != 0)
                            return true;

                        Instance.SelectedMinute = Number(this.innerText);
                        Instance.RefreshInput();
                        Instance.RefreshTime();
                        Instance.Hide(true);
                        return false;
                    })
                    .appendTo(MinuteOptionsFragment);
            }
            $MinuteOptions.append(MinuteOptionsFragment);

            Instance.$TimeContainer.append(Instance.$NowButton = $(document.createElement('div'))
                .addClass("teva-datepicker-time-now")
                .on("click", Instance.Now_Selected)
            );
        }

        private DestoryDateContainer() {
            var Instance = this;
            if (Instance.$DateContainer != null)
                Instance.$DateContainer.remove();
            Instance.$DateCalendar = null;
            Instance.$DateHeader = null;
            Instance.$DateContainer = null;
        }
        private DestoryMonthContainer() {
            var Instance = this;
            if (Instance.$MonthContainer != null)
                Instance.$MonthContainer.remove();
            Instance.$MonthCalendar = null;
            Instance.$MonthHeader = null;
            Instance.$MonthContainer = null;
        }
        private DestoryYearContainer() {
            var Instance = this;
            if (Instance.$YearContainer != null)
                Instance.$YearContainer.remove();
            Instance.$YearCalendar = null;
            Instance.$YearHeader = null;
            Instance.$YearContainer = null;
        }
        private DestoryTimeContainer() {
            var Instance = this;
            if (Instance.$TimeContainer != null)
                Instance.$TimeContainer.remove();
            Instance.$TimeHeader = null;
            Instance.$TimeContainer = null;
        }

        ShowDatePicker(): void {
            var Instance = this;
            Instance.CreateDateContainer();
            Instance.DestoryMonthContainer();
            Instance.DestoryYearContainer();
            Instance.DestoryTimeContainer();

            Instance.RefreshDateCalendar();
        }
        ShowMonthPicker(): void {
            var Instance = this;
            Instance.CreateMonthContainer();
            Instance.DestoryDateContainer();
            Instance.DestoryYearContainer();
            Instance.DestoryTimeContainer();
            Instance.RefreshMonthCalendar();
        }
        ShowYearPicker(): void {
            var Instance = this;
            Instance.CreateYearContainer();
            Instance.DestoryDateContainer();
            Instance.DestoryMonthContainer();
            Instance.DestoryTimeContainer();
            Instance.RefreshYearCalendar();
        }
        ShowTimePicker(): void {
            var Instance = this;
            Instance.CreateTimeContainer();
            Instance.DestoryDateContainer();
            Instance.DestoryMonthContainer();
            Instance.DestoryYearContainer();
            Instance.RefreshTime();
        }

        private RefreshDateCalendar() {
            var Instance = this;
            if (Instance.Mode == DatePickerMode.DateWithoutYear)
                Instance.$DateHeader[0].innerText = Instance.PadNumber(Instance.VisibleMonth, 2);
            else
                Instance.$DateHeader[0].innerText = Instance.PadNumber(Instance.VisibleMonth, 2) + " / " + Instance.VisibleYear;
            Instance.$DateCalendar.empty();
            var CurrentYear = new Date().getFullYear();
            var CurrentMonth = new Date().getMonth() + 1;
            var CurrentDay = new Date().getDate();
            var FullDate = new Date(Instance.VisibleYear, Instance.VisibleMonth - 1, 1);
            FullDate.setDate(FullDate.getDate() - FullDate.getDay());
            var $Fragment = $(document.createDocumentFragment());
            for (var i = 0; i < 7 * 6; i++) {
                $Fragment.append($(document.createElement('div'))
                    .addClass("teva-datepicker-date-options-calendar-item")
                    .data("datepicker-day", FullDate.getDate())
                    .data("datepicker-month", FullDate.getMonth() + 1)
                    .data("datepicker-year", FullDate.getFullYear())
                    .toggleClass("teva-datepicker-date-options-calendar-other", FullDate.getMonth() + 1 != Instance.VisibleMonth)
                    .toggleClass("teva-datepicker-date-options-calendar-selected", FullDate.getDate() == Instance.SelectedDay && FullDate.getMonth() + 1 == Instance.SelectedMonth && FullDate.getFullYear() == Instance.SelectedYear)
                    .toggleClass("teva-datepicker-date-options-calendar-now", FullDate.getDate() == CurrentDay && FullDate.getMonth() + 1 == CurrentMonth && FullDate.getFullYear() == CurrentYear)
                    .on("click", Instance.DatePicker_Selected)
                    .text(Instance.HebrewCalendar ? HebrewDateHelpers.MonthDayNames()[FullDate.getDate() - 1] : FullDate.getDate()));
                FullDate.setDate(FullDate.getDate() + 1);
            }
            Instance.$DateCalendar.append($Fragment);
            if (Instance.Mode == DatePickerMode.DateWithoutYear)
                Instance.$NowButton[0].innerText = DatePicker.LocaleProvider.SelectCurrentDay() + " - " + DatePicker.GetDateWithoutYearAsString(new Date());
            else
                Instance.$NowButton[0].innerText = DatePicker.LocaleProvider.SelectCurrentDay() + " - " + DatePicker.GetDateAsString(new Date());
        }
        private RefreshMonthCalendar() {
            var Instance = this;
            Instance.$MonthHeader[0].innerText = Instance.VisibleYear;
            Instance.$MonthCalendar.empty();
            var CurrentYear = new Date().getFullYear();
            var CurrentMonth = new Date().getMonth() + 1;
            var MonthNames = Instance.HebrewCalendar ? HebrewDateHelpers.MonthNames(Instance.VisibleYear) : DatePicker.LocaleProvider.MonthNames();
            var $Fragment = $(document.createDocumentFragment());
            for (var Month = 1; Month < MonthNames.length + 1; Month++) {
                $Fragment.append($(document.createElement('div'))
                    .addClass("teva-datepicker-month-calendar-item")
                    .data("datepicker-month", Month)
                    .toggleClass("teva-datepicker-month-calendar-selected", Month == Instance.SelectedMonth && Instance.SelectedYear == Instance.VisibleYear)
                    .toggleClass("teva-datepicker-month-calendar-now", Month == CurrentMonth && Instance.VisibleYear == CurrentYear)
                    .on("click", Instance.MonthPicker_Selected)
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-month-calendar-item-number")
                        .text(Month))
                    .append($(document.createElement('div'))
                        .addClass("teva-datepicker-month-calendar-item-text")
                        .text(MonthNames[Month - 1]))
                );
            }
            Instance.$MonthCalendar.append($Fragment);
            Instance.$NowButton[0].innerText = DatePicker.LocaleProvider.SelectCurrentMonth() + " - " + DatePicker.GetMonthAsString(new Date());
        }
        private RefreshYearCalendar() {
            var Instance = this;
            var Year_From = Math.floor(Instance.VisibleYear / 12) * 12;
            var Year_To = Year_From + 12 - 1;
            Instance.$YearHeader[0].innerText = Year_From + " - " + Year_To;

            var CurrentYear = new Date().getFullYear();
            Instance.$YearCalendar.empty();
            var $Fragment = $(document.createDocumentFragment());
            for (var Year = Year_From; Year < Year_To + 1; Year++) {
                $Fragment.append($(document.createElement('div'))
                    .addClass("teva-datepicker-year-calendar-item")
                    .data("datepicker-year", Year)
                    .toggleClass("teva-datepicker-year-calendar-selected", Year == Instance.SelectedYear)
                    .toggleClass("teva-datepicker-year-calendar-now", Year == CurrentYear)
                    .on("click", Instance.YearPicker_Selected)
                    .text(Year));
            }
            Instance.$YearCalendar.append($Fragment);
            Instance.$NowButton[0].innerText = DatePicker.LocaleProvider.SelectCurrentYear() + " - " + new Date().getFullYear();
        }
        private RefreshTime() {
            var Instance = this;
            if (Instance.$TimeHeader != null)
                Instance.$TimeHeader[0].innerText = Instance.PadNumber(Instance.SelectedDay, 2) + " / " + Instance.PadNumber(Instance.SelectedMonth, 2) + " / " + Instance.SelectedYear;
            $(".teva-datepicker-time-hour-selected", Instance.$TimeContainer).val(Instance.PadNumber(Instance.SelectedHour, 2));
            $(".teva-datepicker-time-minute-selected", Instance.$TimeContainer).val(Instance.PadNumber(Instance.SelectedMinute, 2));
            if (Instance.Mode == DatePickerMode.Time)
                Instance.$NowButton[0].innerText = DatePicker.LocaleProvider.SelectCurrentTime() + " - " + DatePicker.GetTimeAsString(new Date());
            else if (Instance.Mode == DatePickerMode.DateTime)
                Instance.$NowButton[0].innerText = DatePicker.LocaleProvider.SelectCurrentTime() + " - " + DatePicker.GetDateTimeAsString(new Date());
        }

        private DatePicker_Selected(Event) {
            var $DayDiv = $(this);
            var DatePicker = <DatePicker>$DayDiv.closest(".teva-datepicker").data("datepicker");
            DatePicker.SelectedYear = DatePicker.VisibleYear;
            DatePicker.SelectedMonth = DatePicker.VisibleMonth;
            DatePicker.SelectedDay = $DayDiv.data("datepicker-day");
            if ($DayDiv.data("datepicker-month")) {
                DatePicker.SelectedMonth = $DayDiv.data("datepicker-month");
                DatePicker.VisibleMonth = DatePicker.SelectedMonth;
            }
            if ($DayDiv.data("datepicker-year")) {
                DatePicker.SelectedYear = $DayDiv.data("datepicker-year");
                DatePicker.VisibleYear = DatePicker.SelectedYear;
            }
            DatePicker.RefreshInput();

            if (DatePicker.Mode == DatePickerMode.DateTime)
                DatePicker.ShowTimePicker();
            else {
                DatePicker.$Input.trigger("focus");
                DatePicker.Hide(true);
            }
            Event.stopPropagation();
        }
        private MonthPicker_Selected(Event) {
            var $MonthDiv = $(this);
            var DatePicker = <DatePicker>$MonthDiv.closest(".teva-datepicker").data("datepicker");
            DatePicker.VisibleMonth = $MonthDiv.data("datepicker-month");
            if (DatePicker.Mode == DatePickerMode.Month) {
                DatePicker.SelectedYear = DatePicker.VisibleYear;
                DatePicker.SelectedMonth = DatePicker.VisibleMonth;
                DatePicker.RefreshInput();
                DatePicker.$Input.trigger("focus");
                DatePicker.Hide(true);
            }
            else
                DatePicker.ShowDatePicker();
            Event.stopPropagation();
        }
        private YearPicker_Selected(Event) {
            var $YearDiv = $(this);
            var DatePicker = <DatePicker>$YearDiv.closest(".teva-datepicker").data("datepicker");
            DatePicker.VisibleYear = $YearDiv.data("datepicker-year");
            DatePicker.ShowMonthPicker();
            Event.stopPropagation();
        }
        private Now_Selected(Event) {
            var DatePicker = <DatePicker>$(this).closest(".teva-datepicker").data("datepicker");

            var Now = new Date();

            if (DatePicker.$YearCalendar != null) {
                DatePicker.SelectedYear = Now.getFullYear();
                DatePicker.VisibleYear = DatePicker.SelectedYear;
                DatePicker.ShowMonthPicker();
            }
            else if (DatePicker.$MonthCalendar != null) {
                DatePicker.SelectedYear = Now.getFullYear();
                DatePicker.SelectedMonth = Now.getMonth() + 1;
                DatePicker.VisibleYear = DatePicker.SelectedYear;
                DatePicker.VisibleMonth = DatePicker.SelectedMonth;
                if (DatePicker.Mode == DatePickerMode.Month) {
                    DatePicker.RefreshInput();
                    DatePicker.$Input.trigger("focus");
                    DatePicker.Hide(true);
                }
                else
                    DatePicker.ShowDatePicker();
            }
            else if (DatePicker.$DateCalendar != null) {
                DatePicker.SelectedYear = Now.getFullYear();
                DatePicker.SelectedMonth = Now.getMonth() + 1;
                DatePicker.SelectedDay = Now.getDate();
                DatePicker.VisibleYear = DatePicker.SelectedYear;
                DatePicker.VisibleMonth = DatePicker.SelectedMonth;
                DatePicker.RefreshInput();
                if (DatePicker.Mode == DatePickerMode.DateTime)
                    DatePicker.ShowTimePicker();
                else {
                    DatePicker.$Input.trigger("focus");
                    DatePicker.Hide(true);
                }
            }
            else {
                DatePicker.SelectedYear = Now.getFullYear();
                DatePicker.SelectedMonth = Now.getMonth() + 1;
                DatePicker.SelectedDay = Now.getDate();
                DatePicker.VisibleYear = DatePicker.SelectedYear;
                DatePicker.VisibleMonth = DatePicker.SelectedMonth;
                DatePicker.SelectedHour = Now.getHours();
                DatePicker.SelectedMinute = Now.getMinutes();
                DatePicker.RefreshInput();
                DatePicker.RefreshTime();
                DatePicker.Hide(true);
            }

            Event.stopPropagation();
        }

        private RefreshInput() {
            var Instance = this;
            switch (Instance.Mode) {
                case DatePickerMode.Date:
                    Instance.$Input.val(Instance.PadNumber(Instance.SelectedDay, 2) + "/" + Instance.PadNumber(Instance.SelectedMonth, 2) + "/" + Instance.SelectedYear);
                    break;
                case DatePickerMode.Month:
                    Instance.$Input.val(Instance.PadNumber(Instance.SelectedMonth, 2) + "/" + Instance.SelectedYear);
                    break;
                case DatePickerMode.Time:
                    Instance.$Input.val(Instance.PadNumber(Instance.SelectedHour, 2) + ":" + Instance.PadNumber(Instance.SelectedMinute, 2));
                    break;
                case DatePickerMode.DateTime:
                    Instance.$Input.val(Instance.PadNumber(Instance.SelectedDay, 2) + "/" + Instance.PadNumber(Instance.SelectedMonth, 2) + "/" + Instance.SelectedYear + " " + Instance.PadNumber(Instance.SelectedHour, 2) + ":" + Instance.PadNumber(Instance.SelectedMinute, 2));
                    break;
                case DatePickerMode.DateWithoutYear:
                    Instance.$Input.val(Instance.PadNumber(Instance.SelectedDay, 2) + "/" + Instance.PadNumber(Instance.SelectedMonth, 2));
                    break;
            }
            Instance.$Input
                .data("datepicker-skipfix", true)
                .trigger("change")
                .data("datepicker-skipfix", false);
        }

        private PadNumber(Value, Length) {
            var ToReturn = String(Value);
            while (ToReturn.length < Length)
                ToReturn = "0" + ToReturn;
            return ToReturn;
        }

        private static FixDateTime($Element): void {
            if ($Element.data("datepicker-skipfix"))
                return;

            var Value = (<string>$Element.val()).trim();
            if (Value.indexOf(' ') != -1) {
                var DatePart = Value.substring(0, Value.indexOf(' ')).trim();
                var TimePart = Value.substring(Value.indexOf(' ') + 1).trim();
                DatePart = DatePicker.ExtractDate(DatePart);
                TimePart = DatePicker.ExtractTime(TimePart);
                if (DatePart != null && TimePart != null && Value != DatePart + " " + TimePart)
                    $Element.val(DatePart + " " + TimePart);
            }
            else if (Value.indexOf(':') != -1) {
                TimePart = DatePicker.ExtractTime(Value);
                if (TimePart != null)
                    $Element.val(DatePicker.GetDateAsString(new Date()) + " " + TimePart);
                else {
                    if (DatePicker.FixDate($Element))
                        $Element.val($Element.val() + " 00:00");
                }
            }
            else {//if (Value.indexOf('/') != -1 || Value.indexOf('-') != -1 || Value.indexOf('.') != -1) {
                var Result = DatePicker.ExtractDate(Value);

                if (Result != null)
                    $Element.val(Result + " 00:00");
            }
        }
        private static FixDate($Element): boolean {
            if ($Element.data("datepicker-skipfix"))
                return false;

            var Value = <string>$Element.val();
            var Result = DatePicker.ExtractDate(Value.trim());

            if (Result != null && Value != Result) {
                $Element.val(Result);
                return true;
            }
            return false;
        }
        private static FixMonth($Element): void {
            if ($Element.data("datepicker-skipfix"))
                return;

            var Value = <string>$Element.val();
            var Result = DatePicker.ExtractMonth(Value.trim());

            if (Result != null && Value != Result)
                $Element.val(Result);
        }
        private static FixTime($Element): void {
            if ($Element.data("datepicker-skipfix"))
                return;

            var Value = <string>$Element.val();
            var Result = DatePicker.ExtractTime(Value.trim());

            if (Result != null && Result != Value)
                $Element.val(Result);
        }
        private static FixYear(Year): string {
            if (Number(Year) < 30)
                return "20" + Year;
            else
                return "19" + Year;
        }
        private static FixDateWithoutYear($Element): boolean {
            if ($Element.data("datepicker-skipfix"))
                return false;

            var Value = $Element.val();
            var Result = DatePicker.ExtractDateWithoutYear(Value);

            if (Result != null && Value != Result) {
                $Element.val(Result);
                return true;
            }
            return false;
        }

        private static ExtractDate(Value): string {
            if (Value.length == 0)
                return null;
            var Separator = '/';
            var Separator1 = Value.indexOf(Separator);
            if (Separator1 == -1) {
                Separator = '-';
                Separator1 = Value.indexOf(Separator);
            }
            if (Separator1 == -1) {
                Separator = '.';
                Separator1 = Value.indexOf(Separator);
            }

            var Day, Month, Year;
            if (Separator1 != -1) {
                var Separator2 = Value.indexOf(Separator, Separator1 + 1);
                if (Separator2 != -1) {
                    var Separator3 = Value.indexOf(Separator, Separator2 + 1);
                    if (Separator3 == -1) {
                        Day = Value.substring(0, Separator1);
                        Month = Value.substring(Separator1 + 1, Separator2);
                        Year = Value.substring(Separator2 + 1);
                    }
                }
                else {
                    Day = Value.substring(0, Separator1);
                    Month = Value.substring(Separator1 + 1);
                }
            }
            else if (!isNaN(Value)) {
                switch (Value.length) {
                    case 1:
                    case 2:
                        Day = Value;
                        break;
                    case 3:
                        Day = Value.substring(0, 1);
                        Month = Value.substring(1, 3);
                        break;
                    case 4:
                        Day = Value.substring(0, 2);
                        Month = Value.substring(2, 4);
                        break;
                    case 6:
                        Day = Value.substring(0, 2);
                        Month = Value.substring(2, 4);
                        Year = Value.substring(4, 6);
                        break;
                    case 8:
                        Day = Value.substring(0, 2);
                        Month = Value.substring(2, 4);
                        Year = Value.substring(4, 8);
                        break;
                }
            }
            return DatePicker.GetDateAsStringFromParts(Day, Month, Year);
        }
        private static ExtractTime(Value): string {
            if (Value.length == 0)
                return null;
            var Separator = Value.indexOf(':');
            var Hour, Minute;
            if (Separator != -1) {
                Hour = Value.substring(0, Separator);
                Minute = Value.substring(Separator + 1);
            }
            else if (!isNaN(Value)) {
                switch (Value.length) {
                    case 1:
                    case 2:
                        Hour = Value;
                        Minute = "0";
                        break;
                    case 3:
                        Hour = Value.substring(0, 1);
                        Minute = Value.substring(1, 3);
                        break;
                    case 4:
                        Hour = Value.substring(0, 2);
                        Minute = Value.substring(2, 4);
                        break;
                }
            }
            if (Hour == null || isNaN(Hour))
                Hour = "0";
            if (Minute == null || isNaN(Minute))
                Minute = "0";
            return DatePicker.GetTimeAsStringFromParts(Hour, Minute);
        }
        private static ExtractMonth(Value): string {
            if (Value.length == 0)
                return null;

            var SeparatorIndex = Value.indexOf('/');
            if (SeparatorIndex == -1)
                SeparatorIndex = Value.indexOf('-');
            if (SeparatorIndex == -1)
                SeparatorIndex = Value.indexOf('.');

            var Month, Year;
            if (SeparatorIndex != -1) {
                if (Value.length == 7)
                    return null;
                if (Value.length == 5 && SeparatorIndex == 2) {
                    Month = Value.substring(0, 2);
                    Year = Value.substring(3, 5);
                }
                else if (Value.length == 4 && SeparatorIndex == 1) {
                    Month = Value.substring(0, 1);
                    Year = Value.substring(2, 4);
                }
            }
            else if (!isNaN(Value)) {
                switch (Value.length) {
                    case 1:
                    case 2:
                        Month = Value;
                        break;
                    case 3:
                        Month = Value.substring(0, 1);
                        Year = Value.substring(1, 3);
                        break;
                    case 4:
                        Month = Value.substring(0, 2);
                        Year = Value.substring(2, 4);
                        break;
                    case 6:
                        Month = Value.substring(0, 2);
                        Year = Value.substring(2, 6);
                        break;
                }
            }
            return DatePicker.GetMonthAsStringFromParts(Month, Year);
        }
        private static ExtractDateWithoutYear(Value): string {
            var Separator = '/';
            var Separator1 = Value.indexOf(Separator);
            if (Separator1 == -1) {
                Separator = '-';
                Separator1 = Value.indexOf(Separator);
            }
            if (Separator1 == -1) {
                Separator = '.';
                Separator1 = Value.indexOf(Separator);
            }

            if (Separator1 != -1)
                return DatePicker.GetDateWithoutYearAsStringFromParts(Value.substring(0, Separator1), Value.substring(Separator1 + 1));
            else if (Value.indexOf(Separator) == -1 && !isNaN(Value)) {
                if (Value.length == 3)
                    return DatePicker.GetDateWithoutYearAsStringFromParts(Value.substring(0, 1), Value.substring(1, 3));
                else if (Value.length == 4)
                    return DatePicker.GetDateWithoutYearAsStringFromParts(Value.substring(0, 2), Value.substring(2, 4));
            }
            return null;
        }

        public static GetTimeAsString(Value: Date) {
            if (Value == null)
                return "";
            return DatePicker.GetTimeAsStringFromParts(Value.getHours().toString(), Value.getMinutes().toString());
        }
        public static GetDateAsString(Value: Date): string {
            if (Value == null)
                return "";
            return DatePicker.GetDateAsStringFromParts(Value.getDate().toString(), (Value.getMonth() + 1).toString(), Value.getFullYear().toString());
        }
        public static GetDateTimeAsString(Value: Date): string {
            if (Value == null)
                return "";
            return DatePicker.GetDateAsString(Value) + " " + DatePicker.GetTimeAsString(Value);
        }
        public static GetMonthAsString(Value: Date): string {
            if (Value == null)
                return "";
            return DatePicker.GetMonthAsStringFromParts((Value.getMonth() + 1).toString(), Value.getFullYear().toString());
        }
        public static GetDateWithoutYearAsString(Value: Date): string {
            if (Value == null)
                return "";
            return DatePicker.GetDateWithoutYearAsStringFromParts(Value.getDate().toString(), (Value.getMonth() + 1).toString());
        }
        public static GetTimeAsStringFromParts(Hour: string, Minute: string): string {
            if (Hour.length == 1)
                Hour = "0" + Hour;
            if (Minute.length == 1)
                Minute = "0" + Minute;
            return Hour + ":" + Minute;
        }
        public static GetMonthAsStringFromParts(Month: string, Year: string): string {
            if (Month == null)
                Month = (new Date().getMonth() + 1).toString();
            if (Year == null)
                Year = new Date().getFullYear().toString();
            if (Number(Month) < 1)
                Month = "01";
            else if (Number(Month) > 12)
                Month = "12";
            else if (Month.length == 1)
                Month = "0" + Month.substring(0, 1);
            return Month + "/" + DatePicker.GetYearAsStringFromParts(Year);
        }
        public static GetDateAsStringFromParts(Day: string, Month: string, Year: string): string {
            Year = DatePicker.GetYearAsStringFromParts(Year);
            return DatePicker.GetDateWithoutYearAsStringFromParts(Day, Month, Year) + "/" + Year;
        }
        public static GetYearAsStringFromParts(Year: string): string {
            if (Year == null)
                Year = new Date().getFullYear().toString();
            else if (Year.length == 1)
                Year = "200" + Year;
            else if (Year.length == 2)
                Year = DatePicker.FixYear(Year);
            return Year;
        }

        public static GetDateWithoutYearAsStringFromParts(Day: string, Month: string, Year?: string): string {
            if (Month == null)
                Month = (new Date().getMonth() + 1).toString();
            else if (Number(Month) < 1)
                Month = "1";
            if (Day == null)
                Day = new Date().getDate().toString();
            else if (Number(Day) < 1)
                Day = "1";
            else if (Number(Day) > 28) {
                var DaysInMonth = new Date(Year == null ? 2020 : Number(Year), Number(Month), 0).getDate();
                if (Number(Day) > DaysInMonth)
                    Day = DaysInMonth.toString();
            }
            if (Day.length == 1)
                Day = "0" + Day;
            if (Month.length == 1)
                Month = "0" + Month;

            return Day + "/" + Month;
        }
        public static GetDateFromString(Value: string, Mode: DatePickerMode) {
            if (Value == null || Value.length == 0)
                return null;
            switch (Mode) {
                case DatePickerMode.DateTime:
                    var Day = Number(Value.substring(0, 2));
                    var Month = Number(Value.substring(3, 5));
                    var Year = Number(Value.substring(6, 10));
                    var Hour = Number(Value.substring(11, 13));
                    var Minute = Number(Value.substring(14, 16));
                    return new Date(Year, Month - 1, Day, Hour, Minute);
                case DatePickerMode.Date:
                    var Day = Number(Value.substring(0, 2));
                    var Month = Number(Value.substring(3, 5));
                    var Year = Number(Value.substring(6, 10));
                    return new Date(Year, Month - 1, Day);
                case DatePickerMode.Month:
                    var Month = Number(Value.substring(0, 2));
                    var Year = Number(Value.substring(3, 7));
                    return new Date(Year, Month - 1, 1);
                case DatePickerMode.Time:
                    var Hour = Number(Value.substring(0, 2));
                    var Minute = Number(Value.substring(3, 5));
                    var Now = new Date();
                    return new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), Hour, Minute);
                case DatePickerMode.DateWithoutYear:
                    var Day = Number(Value.substring(0, 2));
                    var Month = Number(Value.substring(3, 5));
                    return new Date(2000, Month - 1, Day);
                default:
                    console.error("Invalid Mode: " + Mode);
            }
        }
        public static ParseJsonDate(Value: string): Date {
            if (Value.indexOf("/Date(") == 0)
                return new Date(parseInt(Value.replace('/Date(', '')));
            else
                return new Date(Value);
        }
        public static HideAll() {
            $(document).trigger("click.datepicker-hide");
        }
        private GetDaysInMonth(Month: number, Year: number): number {
            if (this.HebrewCalendar)
                return HebrewDateHelpers.DaysInMonth(Month, Year);
            else
                return DatePicker.DaysInMonth(Month, Year);
        }


        public static DaysInMonth(Month: number, Year: number): number {
            return new Date(Year, Month, 0).getDate();
        }
        private static LocaleProvider: DatePickerLocaleProvider;

        private $Input;
        private $Container;

        private $DateContainer;
        private $DateHeader;
        private $DateCalendar;
        private $NowButton;

        private $MonthContainer;
        private $MonthHeader;
        private $MonthCalendar;

        private $YearContainer;
        private $YearHeader;
        private $YearCalendar;

        private $TimeContainer;
        private $TimeHeader;

        private Mode: DatePickerMode;
        private HebrewCalendar: boolean;

        private VisibleYear;
        private VisibleMonth;

        private SelectedYear;
        private SelectedMonth;
        private SelectedDay;
        private SelectedHour;
        private SelectedMinute;
    }
}

$(document).on("Teva.Init", function () {
    Teva.DatePicker.Init();
});

$(document).on("Teva.PageLoad", function () {
    Teva.DatePicker.PageLoad();
});

$(document).on("OG.ModalLoading", function (Event, Container) {
    Teva.DatePicker.HideAll();
});
